import { list as getList, show } from "~/api/contractDomainRecord";
import * as types from "../mutation-types";
import store from "../../store";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";

/**
 * Initial state
 */
export const state = {
  list: null,
  domain: null,
  isLoading: null,
  isInitialLoadPending: true
};

/**
 * Mutations
 */
export const mutations = {
  [types.SET_IS_LOADING_CONTRACT_DOMAIN_RECORDS](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_DOMAIN_RECORDS](state, recordsList) {
    state.list = recordsList.data;
    state.isInitialLoadPending = false;
  },
  [types.SET_CONTRACT_DOMAIN](state, domain) {
    state.domain = domain.data;
  }
};

/**
 * Actions
 */
export const actions = {
  fetchContractDomainRecords({ commit }, { domainId, contractId = null } = {}) {
    commit(types.SET_IS_LOADING_CONTRACT_DOMAIN_RECORDS, true);

    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    getList(activeContractId, domainId).then((response) => {
      let { data } = response;
      commit(types.SET_CONTRACT_DOMAIN_RECORDS, data);
      commit(types.SET_IS_LOADING_CONTRACT_DOMAIN_RECORDS, false);
    });
  }
};

/**
 * Getters
 */
export const getters = {
  list: (state) => state.list,
  domain: (state) => state.domain,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  isLoading: (state) => state.isLoading,
  ...entityStoreStatus.getters
}; 